<template>
  <section class="networkSearch">
    <div class="inner row3_1 flex mobileFlexCol">
      <article class="wd100">
        <section>
            <div class="categoryBox wd100 flex" style="gap: 1rem; margin-bottom: 1rem;">
              <button @click="handleCategoryClick('')" :class="{ 'active': category === '' }" class="categoryBtn">
                전체
              </button>
              <button @click="handleCategoryClick(item.TITLE)" :class="{ 'active': category === item.TITLE }" class="categoryBtn" v-for="(item, index) in categoryList" :key="index">
                {{ item.TITLE }}
              </button>
                <!-- <button class="categoryBtn" @click="handleCategoryClick('')">
                   전체
                </button>
                <button class="categoryBtn" v-for="(item, index) in categoryList" :key="index" @click="handleCategoryClick(item.TITLE)">
                   {{ item.TITLE }}
                </button> -->
            </div>
            <div class="topContent flex">
                <div class="left flex">
                  <p>총 게시물 {{ !this.lodash.isEmpty(items) ? this.totalCnt : "0" }}</p>
                  <!-- <p>총 <span>{{ totalCnt }}</span>건</p> -->
                  <p>페이지 {{ currentPage }} / {{ totalPage }}</p>
                </div>
                <div class="right flex">
                    <select name="searchType" id="searchType" v-model="searchType"  class="selectCustom" style="margin-right: 0.7rem;">
                      <option v-for="(item, index) in searchTypeList" :key="index" :value="item.value">
                        {{ item.name }}
                      </option>
                    </select>
                    <input type="text" class="searchInput" v-model="searchText" @keyup.enter="onClickSearch"/>
                    <input type="button" value="검 색" class="searchBtn searchBtnCmmn mobile-exception" @click="onClickSearch()" />
                    <input type="button" value="검색초기화" class="searchResetBtn searchBtnCmmn" @click="initSearch()"/>
                    <!-- <div v-show="getUser.roleName == $role.ADMIN" class="btn-wrap flex" style="gap: 0.5rem; margin-left: 0.5rem;"> -->
                    <div v-if="isAdmin" class="btn-wrap flex" style="gap: 0.5rem; margin-left: 0.5rem;">
                      <button type="button" class="blue" @click="onClickAdd">등록</button>
                      <button type="button" class="white" @click="onClickModify">수정</button>
                      <button type="button" class="red" @click="onClickDelete">삭제</button>
                      <button type="button" class="blue" @click="modalWrite">카테고리 관리</button>
                    </div>
                    <ModalAgeTechCategory 
                        v-if="isShowModal" 
                        v-bind:isModify=isModify 
                        v-bind:mod_category=mod_category
                        v-bind:mod_categoryIdx=mod_categoryIdx
                        @modal-closed='handleModalClosed'/>
                </div>
            </div>
            <div class="tableContainer" v-if="items && items.length">
              <!-- <input type="file" @change="handleFileChange" accept="video/*"> -->
              <div class="gridBody">
                    <div class="inner">
                        <div
                            v-for="(item, index) in items"
                            :key="index"
                            :class="`gridItem`"
                        >
                            <div v-if="isAdmin" class="checkboxWrap">
                              <input type="checkbox" v-model="selected" :value="item.IDX"/>
                            </div>
                          <div class="searchResultItem">
                            <!-- VIMEO 링크가 있을 때 -->
                            <router-link :to="`ageTechServiceDetail/` + item.IDX" class="gridImgBox">
                            <div v-if="item.VIMEO_LINK" class="iframeContainer" :src="getVimeoLink(item)">
                              <img v-if="item.IMG_FILE_NAME" :src="getThumbnailUrl(item.IMG_FILE_NAME)" alt="Thumbnail" style="width: 200px; height: 200px;">
                              <img v-else :src="item.thumbnailUrl" alt="Thumbnail Image">
                            </div>
                            <!-- 유튜브 링크가 있을 때 -->
                            <div v-if="item.YOUTUBE_LINK" class="iframeContainer">
                              <img v-if="item.IMG_FILE_NAME" :src="getThumbnailUrl(item.IMG_FILE_NAME)" alt="Thumbnail" style="width: 200px; height: 200px;">
                              <img v-else :src="getYoutubeLink(item.YOUTUBE_LINK)" >
                            </div>
                            <!-- 첨부파일이 있을 때 -->
                            <div v-if="item.SAVE_FILE_NAME" class="iframeContainer">
                              <img v-if="item.IMG_FILE_NAME" :src="getThumbnailUrl(item.IMG_FILE_NAME)" alt="Thumbnail" style="width: 200px; height: 200px;">
                              <img v-else :src="getThumbnailUrl(item.TEMP_IMG_FILE_NAME)" alt="Thumbnail" style="width: 200px; height: 200px;">
    <!-- <canvas id="canvas" ref="canvas" style="display: none;"></canvas>
    <img v-if="videoImage" :src="videoImage" alt="Converted Image" id="preview">  -->
                              <!-- <video :src="getVideoUrl(item.SAVE_FILE_NAME)" style="width: 100%; height: 600px;"></video> -->
                            </div>
                            </router-link>

                            <!-- 아무것도 없을 때 -->  
                            <div v-if="!item.VIMEO_LINK && !item.YOUTUBE_LINK && !item.SAVE_FILE_NAME" class="imgBox" :style="{backgroundImage:`url('${getAvatarLink(item.avater)}')`}" ></div>
                            
                            <router-link :to="`ageTechServiceDetail/` + item.IDX" class="gridImgBox">
                            <div class="info-box">
                              <div class="category">
                                  <p style="font-size: 3.3rem;">{{ item.CATEGORY_TITLE }}</p>
                              </div>
                              <div class="title flex jus-bet">
                                  <p>{{ item.TITLE }}</p>
                              </div>
                              <div class="sub-title flex jus-bet">
                                  <span>{{ item.CONTENT }}</span>
                              </div>
                              <div class="etc-info flex jus-bet">
                                  <span>{{ item.REGDATE }}</span>
                                  <span>조회수 : {{ item.VIEW_CNT }}</span>
                              </div>
                              </div>
                            </router-link> 
                          </div>
                        </div>
                    </div>
                </div>
                <paginate
                    aria-controls="table"
                    v-model="currentPage"
                    :page-count="navCnt"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="onClickPagination"
                    :prev-text="'‹'"
                    :next-text="'›'"
                    :container-class="'pagination b-pagination newPagination'">
                </paginate>
            </div>
            <div class="table-empty-row" v-else>
                등록된 게시물이 없습니다.
            </div>
        </section>
      </article>
    </div>
  </section>
</template>

<script>
import {mapGetters , } from "vuex";
import axios from "@/axios/axios";
import { resolveApiUrl } from "@/data/url";
import axiosJsonp from 'axios-jsonp';
import ModalAgeTechCategory from '@/components/ageTechService/popup/ModalAgeTechCategory'
// import PaginationMatching from "@/components/general/PaginationMatching.vue";

export default {
  name: "AgeTechService",
  components : {
    ModalAgeTechCategory
  },
  computed: {
    ...mapGetters("auth", ["getUser"]),
    isAdmin() {
      if (this.getUser != null && this.getUser.roleName == this.$role.ADMIN) {
        return true;
      } else {
        return false;
      }
    },
    totalPage(){
        if (this.totalCnt == 0) return 1
        else if(this.totalCnt % this.perPage == 0) return this.totalCnt/this.perPage
        else return Math.floor(this.totalCnt/this.perPage) + 1
    },
    navCnt : function(){
        if(this.totalCnt % this.perPage == 0) return this.totalCnt / this.perPage
        else return Math.floor(this.totalCnt/this.perPage) + 1;
    },
  },
  data() {
    return {
      thumbnailUrl: null,
      isShowModal: false,
      isModify: false,
      mod_category: '',
      mod_categoryIdx: 0,
      category: '',
      categoryList: [],
      searchType: 1,
      searchTypeList: [
        {name: "전체", value:"1"},
        {name: "제목", value:"2"},
        {name: "내용", value:"3"},
      ],
      searchText: '',
      totalCnt: 0,
      currentPage: 1,
      sortBy: 'REGDATE',
      sortDesc: true,
      perPage: 9,
      selected: [],
      items: [],
      activeItem: null,
      params: {
        isCorp: true,
        name: "",
        id: "",
        industryIdx: "",
        activityIdx: "",
      },
      idx : this.$route.params.idx,
      title: "",
      content: "",
      name: "",
      regDate: "",
      viewCnt: "",
      fileList: null,
      link: null,
      prevNotice: null,
      nextNotice: null,
      videoImage: null
    };
  },
  mounted() {
    this.getList();
    this.getCategoryList();
  },
  methods: {
    async handleFileChange(event) {
      const file = event.target.files[0];
      // console.log("index:"+file)
      if (file && file.type.startsWith('video/')) {
        const video = document.createElement('video');
        const canvas = document.querySelector('#canvas');
        const ctx = canvas.getContext('2d');

        video.muted = true;
        video.preload = 'auto';
        video.src = URL.createObjectURL(file);

        video.addEventListener('loadeddata', () => {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          // console.log("canvas.width:"+canvas.width)
//  console.log("canvas.height:"+canvas.height)
          // video.addEventListener('timeupdate', () => {
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            // console.log("ctx:"+ctx)
            const imageUrl = canvas.toDataURL('image/png');
            // console.log("imageUrl:"+imageUrl)
            this.videoImage = imageUrl;
          // });

          // You may want to adjust the duration based on your needs
          video.currentTime = Math.min(5, video.duration);
        });
      }
    },
    async getList() {
      // console.log("searchType:"+this.searchType)
        let param = {
            searchText : this.searchText,
            currentPage: this.currentPage,
            perPage: this.perPage,
            sortBy: this.sortBy,
            sortDesc: this.sortDesc
        }
        await axios.post('/api/video/getVideoList?CATEGORY='+this.category+'&searchType='+this.searchType+'&roleName='+this.getUser.roleName, param)
        .then((response) => {
            const data = response.data
            this.items = data.items
            this.totalCnt = data.totalCnt
            // console.log("VIMEO_LINK:"+this.items[0].VIMEO_LINK)
            if(this.items == null){
                this.items = [];
                this.totalCnt = 0;
            }
        })
        .catch(() => {
            return []
        });
    },
    handleCategoryClick(categoryTitle) {
      // console.log("categoryTitle:"+categoryTitle)
      this.category = categoryTitle;
      this.getList();
    },
    onClickSearch() {
      // console.log("searchText:"+this.searchTypeList)
      this.getList();
    },
    getVideoUrl(saveFileName) {
        return resolveApiUrl(`/api/video/${saveFileName}`);
    },
    getThumbnailUrl(saveFileName) {
      return resolveApiUrl(`/api/video/${saveFileName}`);
    },
    async getVimeoLink(item) {
      const regex = /vimeo\.com\/(\d+)/;
      const match = item.VIMEO_LINK.match(regex);

      if (match) {
        const videoId = match[1];
        const ajaxUrl = `https://vimeo.com/api/v2/video/${videoId}.json`;

        try {
          const response = await axios.get(ajaxUrl, { adapter: axiosJsonp });
          // Set thumbnailUrl for the specific item
          this.$set(item, 'thumbnailUrl', response.data[0].thumbnail_large);
        } catch (error) {
          console.error('Failed to get thumbnail for item:', item, error);
          // Handle error if necessary
        }
      } else {
        console.error('vimeo 링크 형식이 올바르지 않습니다:', item.VIMEO_LINK);
        // Handle invalid link if necessary
      }
    },
    getYoutubeLink(link) {
      // console.log("link:"+link)
        // 유튜브 링크일 경우
        // const link = 'https://youtu.be/Xj4YPgNJx20?si=YIoYW4KfLxXRqh16';
        const regex = /https:\/\/youtu\.be\/([^?]+)\?si=([^&]+)/;
        const match = link.match(regex);
        if (match) {
            const videoId = match[1]; // videoId 추출
            const embed = 'https://img.youtube.com/vi/' + videoId + '/mqdefault.jpg';
            return embed;
        } else {
            console.error('YouTube 링크 형식이 올바르지 않습니다.');
        }
    },
    modalWrite() {
        this.isShowModal = true
    },
    handleModalClosed(){
      this.isShowModal = false
      this.getCategoryList();
		},
    getCategoryList() {
      axios.get('/api/video/getCategoryList')
      .then((response) => {
            this.categoryList = response.data
            // console.log("this.categoryList:"+this.categoryList)
            if(this.categoryList == null){
                this.categoryList = [];
            }
        })
        .catch(() => {
            return []
        });
    },
    search(){
        this.currentPage = 1
        this.getList()
    },
    initSearch(){
        this.searchType = 1
        this.searchText = ''
        this.getList();
    },
    onClickPagination (pageNum) {
        this.currentPage = pageNum;
        this.getList();
    },
    onClickAdd(){
      this.$router.push('/admin/ageTechServiceWrite')
			// this.detailSurveyIdx = null
			// this.isShowModalSurvey = true
		},
    onClickModify() {
      const selected = this.selected
            
            if(selected.length === 0){
                this.$alert('알림', '게시물을 선택해주세요.')
                return
            }

            if(selected.length > 1){
                this.$alert('알림', '게시물을 하나만 선택해주세요.')
                return
            }

            const idx = selected[0]

            this.$router.push({ path : '/admin/ageTechServiceModify/' + idx });
    },
    onClickDelete(){
			let selected = this.selected;
			if(selected.length == 0){
				this.$alert("알림", "삭제할 게시물을 선택해주세요.")
				return
			}

			var response = this.$createConfirmResponse()
      this.$confirm("알림", `${selected.length}개의 항목을 삭제하시겠습니까?`, "확인", "취소", response, {
				'closed': () => {
					if(response.result){
						let paramDatas = { list: selected };
            axios.post('/api/admin/video/delete', paramDatas)
                .then(result => {
                    if (result.status == 200) {
                        this.$alert("알림", `게시글이 삭제되었습니다.`, "", {
                            'closed': () => {
                              selected = [];
                              this.getList();
                            }
                        });
                    }
                    else {
                        this.$alert("알림", `게시글 삭제에 실패하였습니다.`);
                    }
                })
                .catch((error) => {
                    this.$alert("알림", `게시글 삭제에 실패하였습니다. <br>` + error);
                });
					}
				}
			});
		},
    // getUser() {
      
    //   return "ROLE_ADMIN"
    // },

    onchange(currentParams) {
      this.params = this.lodash.merge(this.params, currentParams);
      this.getDatas();
    },
    getDatas() {
      // const that = this;
      // let params = {
      //       searchText : that.searchText,
      //       currentPage: that.currentPage,
      //       perPage: that.perPage,
      //       sortBy: that.sortBy,
      //       sortDesc: that.sortDesc,
      // }
      // axios
      //   .get("/api/user/searchUser", { params: that.params })
      //   .then((response) => {
      //     that.items = response.data;
      //     that.totalCnt = items.totalCnt;

      //     if(that.items == null) {
      //         that.items = [];
      //         that.totalCnt = 0;
      //     }



      //   })
      //   .catch((error) => {
      //     console.log("error: " + error);
      //     return [];
      //   });
        // axios
        // .get("/api/user/searchUser", { params: that.params })
        // .then((response) => {
        //   that.items = response.data;
        // })
        // .catch((error) => {
        //   console.log("error: " + error);
        //   return [];
        // });
    },
    
  },
};
</script>

<style>
   .gridItem {
    position: relative;
   }
   .checkboxWrap {
    position: absolute;
    left:1rem;
    top:1rem;
    z-index: 3;
   }
   .checkboxWrap  input {
      border:1px solid #494B4C;
      width: 2.7rem;
      height: 2.7rem;
      cursor: pointer;
   }

   .searchInput {width: 20rem;}
   button {white-space: nowrap;}
  .categoryBtn {
    border:0;
    outline: 0;;
     border-radius: 10px;
     padding: 1rem 2rem;    
     font-size: 2.8rem;
     background: #F2F2F2;
     color: #272727;
     cursor: pointer;
  }
  .categoryBtn.active {
    background: #0F0F0F;
     color: #ffffff;
  }
  .selectCustom {
    font-size: 2.4rem;
    line-height: 3.5rem;
    padding: 0.3rem 1.4rem;
  }
  .categoryBox {
    display: flex;
    flex-wrap: wrap;
  }
</style>

<style lang="scss" scoped>
// section 2
.directMatching {
  display: flex;
  border-bottom: 1px solid #d6d6d6;
  justify-content: space-between;
}

.btn-wrap button {
  outline: none;
  border: none;
  padding: 0 1rem ;
  cursor: pointer;
  font-size: 2.4rem;
}
.btn-wrap .blue {
  color:#fff;
  background: #26336A;
}
.btn-wrap .white {
  color: #222;
  background: #fff;
  border: 1px solid #666666;
}
.btn-wrap .red {
  color: #fff;
  background: #9e1915;
}

// Section 2
.btn-outlined {
  height: 53px;
  border: 1px solid #989898;
  background-color: #fff;
  width: 100%;
  font-size: 22px;
  margin-top: 16px;
  cursor: pointer;
}

.table-empty-row {
    text-align:center;
    padding: 2rem;
    line-height: 1.6;
    font-size: 2rem;
}
.gridBody > .inner {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 3rem 8rem;
    gap: 4rem 8rem;
}
.searchResultItem .info-box {
  padding: 1rem;
  border: 1px solid #B0B0B0;
  border-top: 0px solid #B0B0B0;
}
.searchResultItem>.imgBox {
    margin-bottom: 0;
    border-radius: 0;
    border: 1px solid #B0B0B0;
    border-bottom: 0;
    background-repeat: no-repeat; 
    background-position: center;
    object-fit: cover;
}
.searchResultItem>.title {
   min-height: auto;
   height: auto;
   margin-bottom: auto;
}

.iframeContainer {
    position: relative;
    height: 0;
    padding-bottom: 93%;
     /* 16:9 비율에 따라 설정. 다른 비율의 경우 조절이 필요할 수 있습니다. */
}

.iframeContainer img {
    position: absolute;
    width: 100% !important;
    height: 100% !important;
    top: 0;
    left: 0;
}
#preview {
    // margin: 1em 0;
    // display: block;
    // background: rgb(240, 240, 240);
    // border: 1px solid rgb(0,0,0);
    // height: 50%;
    // width: 50%;
}

@media screen and (max-width: 460px) {
  
  .categoryBox {
    display: flex;
    flex-wrap: wrap;
  }
  .topContent {
    display: flex;
    flex-wrap: wrap;
  }
  .topContent .right {
    flex-wrap: wrap;
  }
  .topContent .right .btn-wrap {
    margin-left : 0px !important; 
    margin-top: 1rem;
  }
  .topContent .right .btn-wrap button {height: auto; padding: 0.5rem;}

  .gridBody > .inner {grid-template-columns: repeat(1, 1fr); padding: 3rem 0rem;}

  .mobile-exception {position: static; width: 8rem;
    background: #26336a;
    margin: 0 0.4rem; height: auto; font-size: 2.4rem;
  }
}
</style>
